import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, Table, Input, Button, Tooltip, message } from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_tqa_a01,
  req_downloadfile_tqa_a01,
  req_delete_tqa_a01,
  req_copy_tqa_a01,
  req_edit_tqa_a01,
} from "../../api";
const { TextArea } = Input;

class SchoolQuailtyA01 extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    manual: PropTypes.object,
  };

  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    rooms: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    academicYear: this.props.manual.AcademicYear,
    isShowDetailsModal: false,
    isUploadModal: false,
    recordDescription: "",
    startdate: "",
    enddate: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_tqa_a01(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_tqa_a01(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_tqa_a01(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_copy_item = async (oldYear, newYear) => {
    const { token, userCode } = this.props.user;
    const result = await req_copy_tqa_a01(oldYear, newYear, userCode, token);

    if (result.status === "success") {
      message.success("複製成功");
      this.api_page_items(this.current);
    } else {
      message.info(newYear + "年度已有資料，複製失敗");
    }
  };

  api_edit_item = async (row) => {
    const token = this.props.user.token;
    //console.log(row)
    const result = await req_edit_tqa_a01(row, token);
    if (result.status === "success") {
      // 1 結果提示
      message.success("編輯成功");
      this.setState({ isShowModal_edit_item: false });
      // 2 更新列表
      this.api_page_items(this.current);
    } else {
      console.log(result);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    console.log(
      this.props.manual.academicYear
        ? this.props.manual.academicYear
        : "沒有此屬性"
    );
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 25,
        fixed: "left",
      },
      {
        title: "教育目標",
        width: 50,
        render: (item) => {
          const { RecordDescription, RecordStatus } = item;
          return (
            <>
              {RecordStatus === "DONE" ? (
                <>{RecordDescription}</>
              ) : (
                <>
                  {" "}
                  <TextArea
                    rows={4}
                    placeholder="最少5個字"
                    defaultValue={RecordDescription}
                    allowClear
                    onChange={(e) => this.onChangeTextArea(e)}
                  />
                </>
              )}
            </>
          );
        },
      },
      {
        title: "",
        width: 25,
        fixed: "right",
        render: (item) => {
          const { RecordStatus } = item;
          return (
            <>
              {this.props.manual.academicYear ? (
                ""
              ) : (
                <button
                  className="btn btn-outline-dark btn-sm"
                  style={{ width: "82px" }}
                  onClick={() => this.handle_ui_modal("EDIT", item)}
                  disabled={RecordStatus === "DONE"}
                >
                  <i className="fa fa-check-circle"></i> 儲存
                </button>
              )}
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  onChangeTextArea = (e) => {
    //console.log(e.target.value);
    this.setState({
      recordDescription: e.target.value,
    });
  };
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "COPY":
        const { academicYear } = this.state;
        this.api_copy_item(
          academicYear,
          (parseInt(academicYear) + 1).toString()
        );
        break;
      case "EDIT":
        const { userCode } = this.props.user;
        const { Uid } = item;
        const { recordDescription } = this.state;
        const obj = {
          Uid,
          RecordDescription: recordDescription,
          RecordStatus: "DONE",
          RecordEditor: userCode,
          condition: "BASE",
        };
        this.api_edit_item(obj);
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, academicYear } = this.state;
    const workmenu = (
      <>
        {this.props.manual.academicYear ? (
          ""
        ) : (
          <>
            {" "}
            <Input
              placeholder="學年度"
              style={{
                width: 55,
                margin: "0 5px",
                backgroundColor: "LightYellow",
              }}
              value={academicYear}
              onChange={(event) =>
                this.setState({ academicYear: event.target.value })
              }
            />
            <Tooltip placement="top" title="重新整理">
              <Button
                type="primary"
                onClick={() => this.handle_data_refresh()}
                style={{ marginRight: "4px" }}
              >
                <i className="fas fa-sync-alt"></i>
              </Button>
            </Tooltip>
            {items.length > 0 && (
              <Button
                type="primary"
                onClick={() => this.handle_ui_modal("COPY", {})}
                style={{ marginRight: "4px" }}
              >
                <i
                  className="fa fa-object-ungroup"
                  style={{ paddingRight: "2px" }}
                ></i>
                複製
              </Button>
            )}
          </>
        )}
        <Button
          type="primary"
          onClick={() => this.handle_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "2px" }}></i>
          匯出
        </Button>
        <p></p>
      </>
    );

    return (
      <>
        <Card title="A01-校教育目標">
          {workmenu}
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
      </>
    );
  }
}
export default connect((state) => ({ user: state.user }), {})(SchoolQuailtyA01);
